import { useState, useEffect, useRef } from 'react';
import { Input, AutoComplete } from 'antd';
import { useNavigate } from 'react-router-dom';
import unit from '../unit';
import deleteImg from '../assets/delete.png';
import closeImg from '../assets/close.png';

// 移除forwardRef，使用普通组件定义方式
const SearchComponent = (props) => {
    const [options, setOptions] = useState([]);
    const [history, setHistory] = useState([]);
    const [autoStyle, setAutoStyle] = useState({});
    const [size, setSize] = useState('large');
    const [width, setWidth] = useState('400px');
    const [inputValue, setInputValue] = useState(''); // 控制输入框值的状态
    const inputRef = useRef(null);
    const navigate = useNavigate();

    // 搜索框输入后事件
    const handleSearch = (value) => {
        setOptions(value ? onSearch(value) : []);
    };

    // 选中自动补全后事件
    const onSelect = (value, option) => {
        if (value && option) {
            // 使用状态更新输入框值，显示label（名称）
            setInputValue(option.label);

            if (typeof option.label === 'string') {
                // 检查是否已经存在相同的记录
                const existingIndex = history.findIndex(item => item.value === option.value);
                if (existingIndex !== -1) {
                    // 如果存在，移除旧的记录
                    const newHistory = [...history];
                    newHistory.splice(existingIndex, 1);
                    setHistory(newHistory);
                }
                // 添加新的记录到数组开头
                const updatedHistory = [option, ...history.filter(item => item.value !== option.value)];
                // 如果历史记录超过10条，移除最旧的记录
                if (updatedHistory.length > 10) {
                    updatedHistory.pop();
                }
                setHistory(updatedHistory);
                window.localStorage.setItem('searchHistory', JSON.stringify(updatedHistory));
            }

            // 路由跳转仍使用value（编码）
            if (value.length === 6 && (value[0] === '0' || value[0] === '3' || value[0] === '6')) {
                navigate(`/particulars/${value}`);
            } else {
                navigate(`/detail/${value}`);
            }
        }
    };

    // 搜索处理函数
    const onSearch = (keyword) => {
        const path = '/app/search/all';
        unit.httpGet(path, {
            "tab": 8,
            "key": keyword,
            "apiversion": "8.9",
            "page_size": 10
        }, (data) => {
            let gudongSearchList = [];
            let stockSearchList = [];
            let searchList = [];

            if (data && data.list) {
                for (let i = 0; i < data.list.length; i++) {
                    let type = data.list[i].type;
                    if (type === 'gudong') {
                        let gudongList = data.list[i].list;
                        for (let j = 0; j < gudongList.length; j++) {
                            let tmp = {};
                            tmp['value'] = gudongList[j].code;
                            tmp['label'] = gudongList[j].name;
                            gudongSearchList.push(tmp);
                        }
                    } else if (type === 'stock') {
                        let stockList = data.list[i].list;
                        for (let j = 0; j < stockList.length; j++) {
                            let tmp = {};
                            tmp['value'] = stockList[j].code;
                            tmp['label'] = stockList[j].name;
                            stockSearchList.push(tmp);
                        }
                    }
                }
            }
            if (gudongSearchList.length > 0 && stockSearchList.length > 0) {
                searchList.push({ "label": "股东", "options": gudongSearchList });
                searchList.push({ "label": "股票", "options": stockSearchList })
            } else if (gudongSearchList.length > 0) {
                searchList = gudongSearchList;
            } else if (stockSearchList.length > 0) {
                searchList = stockSearchList;
            }
            setOptions(searchList);
        });
    }

    // 组件初始化和更新
    useEffect(() => {
        let historyStore = window.localStorage.getItem('searchHistory');
        if (historyStore) {
            setHistory(JSON.parse(historyStore));
        }
        if (props.isHeader) {
            setAutoStyle({
                width: '300px', lineHeight: "64px"
            });
        } else {
            setAutoStyle({
                width: "580px", height: "50px"
            });
        }
    }, [props.isHeader]);

    // 清空某个历史记录
    const clearHistory = (event, key) => {
        event.stopPropagation();
        const newHistory = history.filter((_, index) => index !== key);
        setHistory(newHistory);
        window.localStorage.setItem('searchHistory', JSON.stringify(newHistory));
        inputRef.current?.blur();
    }

    // 清空所有历史记录
    const clearAllHistory = (event) => {
        event.stopPropagation();
        window.localStorage.removeItem('searchHistory');
        setHistory([]);
        inputRef.current?.blur();
    }

    // 显示历史记录
    const showHistory = () => {
        let searchList = [];
        for (let i = 0; i < history.length; i++) {
            let tmp = {};
            tmp['value'] = history[i].value;
            tmp['label'] = (
                <div className="history-item">
                    <span className="history-text" title={history[i].label}>{history[i].label}</span>
                    <span className="right" onClick={(event) => { clearHistory(event, i) }}>
                        <img src={closeImg} className="history_icon" alt="删除该记录" />
                    </span>
                </div>
            );
            searchList.push(tmp);
        }
        if (searchList.length > 0) {
            searchList.unshift({
                'value': '',
                'label': (
                    <div className="history-header" style={{ color: '#999999', fontSize: '12px' }}>
                        <span className="left">历史搜索记录</span>
                        <span className="right" onClick={(event) => { clearAllHistory(event) }}>
                            <img className="history_icon" src={deleteImg} alt="删除所有记录" />
                            清空
                        </span>
                    </div>
                )
            });
        }
        setOptions(searchList);
    };

    return (
        <div className='search-container'>
            <AutoComplete
                key={props.isHeader ? 1 : 2}
                popupMatchSelectWidth={width}
                style={autoStyle}
                options={options}
                onSelect={onSelect}
                onSearch={handleSearch}
                size={size}
                value={inputValue}
                onChange={setInputValue}
            >
                {props.isHeader ?
                    <Input.Search 
                        className='head-search-btn' 
                        size='middle' 
                        placeholder="搜股票、牛散、机构等" 
                        ref={inputRef} 
                        enterButton 
                        onFocus={showHistory}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                    /> :
                    <Input.Search 
                        className='body-search-btn' 
                        size='large' 
                        placeholder="请输入股票、牛散、基金名称" 
                        ref={inputRef} 
                        enterButton 
                        onFocus={showHistory}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                    />
                }
            </AutoComplete>
        </div>
    );
};

export default SearchComponent;
    